export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // Ignore
  }
};

export const isAdmin = () => {
  const state = loadState();
  try{
    return (state && state.adminUser)
  }
  catch (err){
    return false;
  }
}

export const isUser = () => {
  const state = loadState();
  try{
    return (state && state.user)
  }
  catch (err){
    return false;
  }
}

export const isLoggedIn = () => {
  return (isAdmin() || isUser());
}

export const getUserId = () => {
  //assumes isLoggedIn is true
  if (isUser()){
    return loadState().user.id
  }
  if (isAdmin()){
    return loadState().adminUser.id
  }
}

export const getUserName = () => {
  //assumes isLoggedIn is true
  if (isUser()){
    return loadState().user.fullName
  }
  if (isAdmin()){
    return loadState().adminUser.fullName
  }
}

export const getUserType = () => {
  //assumes isLoggedIn is true
  if (isUser()){
    return "User"
  }
  if (isAdmin()){
    return "AdminUser"
  }
}

export const getUserEmail = () => {
  //assumes isLoggedIn is true
  if (isUser()){
    return loadState().user.email
  }
  if (isAdmin()){
    return loadState().adminUser.email
  }
}

export const getUserStatus = () => {
  //assumes isLoggedIn is true
  if (isUser()){
    return loadState().user.accountStatus
  }
  if (isAdmin()){
    return "Admin"
  }
}

export const getUserMobile = () => {
  if (isUser()){
    return loadState().user.mobile
  }
  return null
}

export const getUserCity = () => {
  if (isUser() && loadState().user.city){
    return loadState().user.city.map(city => city.name).join(', ');
  }
  if (isAdmin()){
    return null; //adminUser.city does not exist in mutation
  }
}


// WEBPACK FOOTER //
// ./src/utils/localStorage.js